import script from "./ModalAddPhoto.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalAddPhoto.vue?vue&type=script&setup=true&lang=js"

import "./ModalAddPhoto.vue?vue&type=style&index=0&id=1acd1fa2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1acd1fa2"]])

export default __exports__